// @flow
import React from 'react';
import { smoothScrollToTop } from 'lib/common';
import './CategoryItem.scss';

type Props = {
  name: string,
};

const CategoryItem = ({ name }: Props) => {
  return (
    <div className="CategoryItem">
      <div className="name">{name}</div>
      <div className="a-z-to-top">
        <span className="nav" onClick={smoothScrollToTop}>
          {' '}
          ↑ 맨 위로
        </span>
      </div>
    </div>
  );
};

export default CategoryItem;



// WEBPACK FOOTER //
// ./src/components/categories/CategoryItem/CategoryItem.js